<template>
	<div class="modal modal-overlay" data-backdrop="static" id="check-before-update-modal" tabindex="-1" role="dialog" aria-labelledby="myModalOptionLabelCheck">
		<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
			<div class="modal-content" style="margin-bottom:5rem;">
				<div class="modal-header">
					<h5 class="modal-title" id="myModalOptionLabelCheck">確認</h5>
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
				</div>
				<div class="modal-body">
					<p>完了済みの議事録を更新します。タスクの更新方法を選択してください。</p>
					<br>
					<p style="color:red">※注意<br>更新(すべて洗い替え)を選択した場合、タスク一覧＞タスク詳細画面で更新した内容が消えます。</p>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary doyes">更新(すべて洗い替え)</button>
					<button type="button" class="btn btn-primary dono">更新(既存タスクを除き)</button>
					<button type="button" class="btn btn-primary" data-dismiss="modal">閉じる</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import $ from "jquery";
export default {
	props: {
	},
	data: () => ({
		
	}),
	
	created() {
		
	},
	
	methods: {

	},
	
	mounted() {
		const _self = this;

		$("#check-before-update-modal button.doyes").on("click", function(e) {
			$(".btn").attr("disabled", true);
			
			_self.$emit('dosave-emit', true);
		});

		$("#check-before-update-modal button.dono").on("click", function(e) {
			$(".btn").attr("disabled", true);

			_self.$emit('dosave-emit', false);
		});
	}
}
</script>
<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  z-index: 1050; /* Bootstrap のモーダルより高い z-index を設定 */
}
</style>